import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalService, ModalOptions, BsModalRef } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CustomService } from '../../../services/frapper/custom.service';
import { DossierService } from '../../../services/frapper/dossier.service';
import { EnrollementService } from '../../../services/frapper/enrollement.service';
import { JugementsService } from '../../../services/frapper/jugements.service';
import { RecoursService } from '../../../services/frapper/recours.service';
import { PenalCourrierService } from '../../../services/penal.courrier/penal.courrier.service';
import { AlertesService } from '../../../services/public/alertes.service';
import * as _ from 'lodash';
import * as $ from 'jquery';
import { ManagementService } from '../../../services/frapper/management.service';
import { TribunalService } from '../../../services/frapper/tribunal.service';
import {AllpageComponent} from "../../../allpage/allpage.component";

@Component({
  selector: 'app-add-tribunal',
  templateUrl: './add-fonction.component.html',
  styleUrls: ['./add-fonction.component.scss']
})
export class AddFonctionComponent {
  my_tribunal:any = null
  list_tribunals:any[] = []
  default_value: any;
  isJudiciaire: any = false;

  is_justiciaire:any
  types_tribunal: any[] = [
    "TI", "TGI", "CA", "AUTRE"
  ]
  list_profil:  any[] = [
    {
      "name": "AGENT DU COURRIER"

    },
    {
      "name": "ADMIN TRIBUNAL"

    },
    {
      "name": "AGENT DU COURRIER CIVIL"

    },
    {
      "name": "AGENT DU COURRIER FAMILIAL"

    },
    {
      "name": "AGENT DU COURRIER SOCIAL"

    },
    {
      "name": "AGENT DU COURRIER PRESIDENT"

    },
    {
      "name": "AGENT DU COURRIER GREF"
    },
    {
      "name": "PROCUREUR"
    },
    {
      "name": "SUB PROCUREUR"
    },
    {
      "name": "GREFFIER"
    },
    {
      "name": "GREFFIER EN CHEF"
    },
    {
      "name": "JUGE D'INSTRUCTION"
    },
    {
      "name": "GREFFIER D'INSTRUCTION"
    },
    {
      "name": "JUGE"
    },
    {
      "name": "PRESIDENT DU TRIBUNAL"
    },
    {
      "name": "AGENT EXECUTION PEINES"
    },
    {
      "name": "AGENT NATURALISATION"
    },
    {
      "name": "AGENT ENROLEMENT"
    },
    {
      "name": "AGENT ENROLEMENT PENAL"
    },
    {
      "name": "AGENT RDV"
    },
    {
      "name": "AGENT DU CASIER"
    },

  ]

    constructor(private modalService: BsModalService,
        public options: ModalOptions,
        private jugementService: JugementsService,
        private recourService:RecoursService,
        private role: EnrollementService,
        private customService:CustomService,
        private alerte:AlertesService,
        public bsModalRef: BsModalRef,
        private customservice:CustomService,
        private dossierService: DossierService,
        private datePipe: DatePipe,
        private managementService: ManagementService,
        private tribunalService: TribunalService,


        private ngxService: NgxUiLoaderService,
        private penalService: PenalCourrierService) {

          this.isJudiciaire = options.initialState.is_justiciaire;
          this.default_value = options.initialState.default_value;
          console.log('params', this.isJudiciaire);
          
    }


    async getAllSysRole() {
    this.ngxService.start();
    try {
      let filter = null//'[ ["is_judiciaire" ,"=", "1"]]'
      this.list_profil = (await this.managementService.getAllSystemRole(filter)).data;
      console.log({'the result list_profil': this.list_profil});
      this.ngxService.stop();

    } catch (error) {

      this.ngxService.stop();
    }
  }

    closeModal(){
        this.bsModalRef.hide()
    }

    closeWithMessage(message: string) {
        this.bsModalRef.hide();
        this.bsModalRef.onHidden.emit(message);
    }

    async onSubmit(form: NgForm){
        this.ngxService.start()

        let body_content = form.value

        this.isJudiciaire? body_content.is_judiciaire = 1 : body_content.is_judiciaire = 0

     // console.log("body_content==> ",body_content)
      //return
        try {
            await this.managementService.nouvelleFunction(body_content)

            this.closeWithMessage("success")
            this.alerte.successNotification("Fonction","Fonction Ajoutée ")
        } catch (error) {
            this.alerte.errorNotification("Fonction", "une erreur est survenue")

        }finally{
            this.ngxService.stop()

        }
        console.log('body_content:', body_content);
    }

    async ngOnInit(){
    await this.getAllSysRole()
        var self = this;


        $(document).ready(function(){
            console.log('dddddd rrreeaady');

            console.log('jjbjjn');
            // Ajouter une nouvelle ligne au tableau
            $('#addRowBtn_inf').on('click', function() {

            });

            // Gérer la suppression d'une ligne
            $('#myTable').on('click', '.delete-row', function() {
                $(this).closest('tr').remove(); // Supprimer la ligne parente (tr) du clic sur l'icône poubelle (delete-row)
            });


        })


        // table infractions
        $('#addRowBtn_inf').on('click', function () {
            // Génère les <option> à partir du tableau
            let tribunals = self.list_tribunals.map(t => `<option value="${t.name}">${t.tribunal}</option>`).join('');
            let types = self.types_tribunal.map(t => `<option value="${t}">${t}</option>`).join('');
            // self.types_tribunal.map(t => `<option value="${t}">${t}</option>`).join('');

            // Nouvelle ligne avec le select
            const newRow = `
            <tr class="text-center">
                <td>
                <select class="form-control" name="name">
                    ${tribunals}
                </select>
                </td>
                <td>
                    <select class="form-control" name="type">
                        ${types}
                    </select>
                </td>
                <td><input type="checkbox" class="" name="is_master" /></td>
                <td>
                <i class="fas fa-solid fa-trash delete-row text-danger mt-2" style="font-size:15px; cursor:pointer"></i>
                </td>
            </tr>
            `;

            $('#myTable tbody').append(newRow);
        });

        $(document).ready(function(){
            var current_fs, next_fs, previous_fs; //fieldsets
            var opacity;
            var current = 1;
            var steps = $("#msform fieldset").length;

            setProgressBar(current);
            if ($("#msform fieldset").hasClass("second")) {
                // Cacher le premier fieldset et afficher le deuxième
                $("#msform fieldset").eq(0).hide();
                $("#msform fieldset").eq(1).show();


                // Ajouter la classe "active" au deuxième élément de la barre de progression
                $("#progressbar li").eq(1).addClass("active");
                console.log("Au moins un élément fieldset a la classe 'cache'");
            }




            // Fonction pour définir la barre de progression
            function setProgressBar(curStep){
                var percent = (100 / steps) * curStep;
                percent = percent
                $(".progress-bar").css("width",percent+"%");
            }

            // Logique pour passer à l'étape suivante
            $(".next").click(function(){
                current_fs = $(this).parent();
                next_fs = $(this).parent().next();

                // Ajouter la classe "active" à l'étape suivante de la barre de progression
                $("#progressbar li").eq($("#msform fieldset").index(next_fs)).addClass("active");

                // Afficher le fieldset suivant avec une animation
                next_fs.show();
                current_fs.animate({opacity: 0}, {
                    step: function(now) {
                        opacity = 1 - now;
                        current_fs.css({
                            'display': 'none',
                            'position': 'relative'
                        });
                        next_fs.css({'opacity': opacity});
                    },
                    duration: 500
                });
                setProgressBar(++current);
            });

            // Logique pour revenir à l'étape précédente
            $(".previous").click(function(){
                current_fs = $(this).parent();
                previous_fs = $(this).parent().prev();

                // Retirer la classe "active" de l'étape actuelle de la barre de progression
                $("#progressbar li").eq($("#msform fieldset").index(current_fs)).removeClass("active");

                // Afficher le fieldset précédent avec une animation
                previous_fs.show();
                current_fs.animate({opacity: 0}, {
                    step: function(now) {
                        opacity = 1 - now;
                        current_fs.css({
                            'display': 'none',
                            'position': 'relative'
                        });
                        previous_fs.css({'opacity': opacity});
                    },
                    duration: 500
                });
                setProgressBar(--current);
            });
        });
    }
}
